import { render, staticRenderFns } from "./MySkills.vue?vue&type=template&id=25e0cce8&scoped=true"
import script from "./MySkills.vue?vue&type=script&lang=js"
export * from "./MySkills.vue?vue&type=script&lang=js"
import style0 from "./MySkills.vue?vue&type=style&index=0&id=25e0cce8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e0cce8",
  null
  
)

export default component.exports